import { module } from 'modujs';

export default class extends module {

    constructor(m) {
        super(m);
        this.events = {
            click: { close: 'hideModal' }
        };
        this.content = this.$( 'content' )[0];
        this.onKeyUpBind = this.onKeyUp.bind( this );
        document.body.addEventListener('keydown', this.onKeyUpBind );

        document.addEventListener( 'click', e => {
            console.log('yes');
            if(e.target.dataset.openModal === this.el.dataset.moduleModal){
                this.showModal();
            }
        });

        this.isVisible = false;

    }
    showModal(){
        this.isVisible = true;
        this.el.classList.remove( ...this.el.dataset.toggleClass.split( ' ' ) );
        this.content.classList.add( ...this.content.dataset.toggleClass.split( ' ' ) );
    }

    hideModal(){
        this.isVisible = false;
        this.el.classList.add( ...this.el.dataset.toggleClass.split( ' ' ) );
        this.content.classList.remove( ...this.content.dataset.toggleClass.split( ' ' ) );
    }

    onKeyUp( e ){
        if( this.isVisible && e.key === 'Escape'  ){
            this.hideModal();
        }
    }

    destroy(){
        window.removeEventListener( 'keyup', this.onKeyUpBind );
    }

}
